import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public list = createGetApi<void>({
    url: '/benefit/list',
  });

  public create = createPostApi<{
    name: string;
    description?: string;
    image?: string;
  }>({
    url: '/benefit/create',
  });

  public update = createPostApi<{
    _id: string;
    name: string;
    description?: string;
    image?: string;
  }>({
    url: '/benefit/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/benefit/remove',
  });
}

export default Apis;
